<script setup lang="ts">
import { ButtonsGroup } from '@/components/Buttons'
import StackLayout from '@/components/Layouts/StackLayout.vue'

type Props = {
    items: {
        label?: string
        icon?: string
    }[]
    value: string | number
}

defineProps<Props>()
defineEmits<{
    (e: 'click', value: string | number): void
}>()
</script>

<template>
    <StackLayout class="place-self-end">
        <ButtonsGroup :items="items" :value="value" @click="$emit('click', $event)" />
    </StackLayout>
</template>
